import { useTranslation } from "react-i18next"
import { TooltipContent, TooltipCustom, TooltipTrigger } from "@/components/ui/tooltip"

const TextWithTooltip = (props: { value: number; title: string }) => {
  return (
    <TooltipCustom>
      <TooltipTrigger>
        <span>{props.value}</span>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        <p>{props.title}</p>
      </TooltipContent>
    </TooltipCustom>
  )
}

interface AvailablePoolGlossaryProps {
  label?: string
  poolCapacity: number
  bookedPoolCapacity: number
  reservedCapacity: number
  overbookedEmergencyCapacity: number
  additionalPoolCapacity: number
  availablePoolCapacity: number
}

export const AvailablePoolGlossary = (props: AvailablePoolGlossaryProps) => {
  const { t } = useTranslation()
  return (
    <span>
      <span>{`${props.label}: (`}</span>
      <TextWithTooltip title={t("scheduling.productivityCockpit.planningChart.pool")} value={props.poolCapacity} />
      {` - `}
      <TextWithTooltip
        title={t("scheduling.productivityCockpit.planningChart.booked")}
        value={props.bookedPoolCapacity}
      />
      {` - `}
      <TextWithTooltip
        title={t("scheduling.productivityCockpit.planningChart.reserved")}
        value={props.reservedCapacity}
      />
      {` - `}
      <TextWithTooltip
        title={t("scheduling.productivityCockpit.planningChart.overbooked")}
        value={props.overbookedEmergencyCapacity}
      />
      {`)`}
      <b>{`${props.additionalPoolCapacity >= 0 ? " + " : " - "}${Math.abs(props.additionalPoolCapacity)}`}</b>
      {` = ${props.availablePoolCapacity}`}
    </span>
  )
}

interface AvailableEmergencyPoolGlossaryProps {
  label?: string
  reservedCapacity: number
  plannedEmergencyCapacity: number
  bookedEmergencyCapacity: number
  additionalReservedCapacity: number
  availableEmergencyCapacity: number
}

export const AvailableEmergencyPoolGlossary = (props: AvailableEmergencyPoolGlossaryProps) => {
  const { t } = useTranslation()
  return (
    <span>
      <span>{`${props.label}: (`}</span>
      <TextWithTooltip
        title={t("scheduling.productivityCockpit.planningChart.reserved")}
        value={props.reservedCapacity}
      />
      {` + `}
      <TextWithTooltip
        title={t("scheduling.productivityCockpit.planningChart.plannedEmergency")}
        value={props.plannedEmergencyCapacity}
      />
      {` - `}
      <TextWithTooltip
        title={t("scheduling.productivityCockpit.planningChart.bookedEmergency")}
        value={props.bookedEmergencyCapacity}
      />
      {`)`}
      <b>{`${props.additionalReservedCapacity >= 0 ? " + " : " - "}${Math.abs(props.additionalReservedCapacity)}`}</b>
      {` = ${props.availableEmergencyCapacity}`}
    </span>
  )
}
